import { Typography, Box } from '@mui/material'
import { CalendarInput } from 'Common/Supplyvue-ui'
import { differenceInCalendarWeeks, addWeeks } from 'date-fns'
import { CreatePlanDataTypes } from '../OperationalPlanner.types'
import { PLAN_DATA_ACTIONS } from './planDataReducer'

interface PlanStartWeekInputProps {
  createPlanDataObject: CreatePlanDataTypes
  dispatch: React.Dispatch<any>
  isPlanCreating: boolean
  horizonsSelectionModeState: {
    planHorizon: string
    constrainingHorizon: string
  }
  setIsSelectedVariantEdited: (edited: boolean) => void
  selectedTemplateKey: string | null
}

export const PlanStartWeekInput = ({
  createPlanDataObject,
  dispatch,
  isPlanCreating,
  horizonsSelectionModeState,
  setIsSelectedVariantEdited,
  selectedTemplateKey,
}: PlanStartWeekInputProps) => {
  const updatePlanStartWeek = (planStartWeek: Date) => {
    let {
      planHorizon,
      constrainingHorizon,
      planHorizonDate,
      constrainingHorizonDate,
    } = createPlanDataObject

    let changed = false

    if (horizonsSelectionModeState.planHorizon === 'weeks') {
      if (planHorizon > 0) {
        planHorizonDate = addWeeks(planStartWeek, planHorizon)
        changed = true
      }
    }
    if (horizonsSelectionModeState.planHorizon === 'date') {
      if (planHorizonDate) {
        planHorizon = differenceInCalendarWeeks(
          new Date(planHorizonDate),
          planStartWeek
        )
        changed = true
      }
    }

    if (horizonsSelectionModeState.constrainingHorizon === 'weeks') {
      if (constrainingHorizon > 0) {
        constrainingHorizonDate = addWeeks(planStartWeek, constrainingHorizon)
        changed = true
      }
    }

    if (horizonsSelectionModeState.constrainingHorizon === 'date') {
      if (constrainingHorizonDate) {
        constrainingHorizon = differenceInCalendarWeeks(
          new Date(constrainingHorizonDate),
          planStartWeek
        )
        changed = true
      }
    }

    dispatch({
      type: PLAN_DATA_ACTIONS.UPDATE_HORIZON_DATA,
      payload: {
        planStartWeek: planStartWeek,
        planHorizonDate,
        constrainingHorizonDate,
        planHorizon,
        constrainingHorizon,
      },
    })

    if (selectedTemplateKey) {
      setIsSelectedVariantEdited(changed)
    }
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        marginTop={2}
      >
        <Box display="flex" alignItems="center" width="20%">
          <Typography>Plan start week</Typography>
        </Box>
        <Box marginLeft={3} width="300px">
          <CalendarInput
            label="Plan start week"
            format="dd-MM-yyyy"
            onChange={updatePlanStartWeek}
            value={createPlanDataObject.planStartWeek}
            disabled={isPlanCreating}
            shouldDisableDate={(date) => date.getDay() !== 1}
          />
        </Box>
        <Box display="flex" alignItems="center" width="20%"></Box>
      </Box>

      {createPlanDataObject.planStartWeek &&
        createPlanDataObject.planStartWeek?.getDay() !== 1 && (
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center" width="20%"></Box>
            <Box color="red" marginLeft={2}>
              Please make sure the selected day is a Monday.
            </Box>
            <Box display="flex" alignItems="center" width="20%"></Box>
          </Box>
        )}
    </>
  )
}
